/**
 * Resolve API origin for fetch calls.
 * Vite inlines import.meta.env at build time — production must never
 * silently fall back to localhost if VITE_API_URL was missing on Netlify.
 */
const PROD_API = 'https://tripnovac-sales-production.up.railway.app';

export function getApiBaseUrl(): string {
  const raw = (import.meta.env.VITE_API_URL as string | undefined) || '';
  const cleaned = raw.trim().replace(/\/+$/, '').replace(/\/api$/i, '');

  if (cleaned && !/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(cleaned)) {
    return cleaned;
  }

  // Built for production (or hosted on tripnovac domain) → always use Railway
  if (import.meta.env.PROD) {
    return PROD_API;
  }

  // Runtime safety net if a bad localhost build somehow ships
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host.includes('tripnovac') || host.includes('netlify.app')) {
      return PROD_API;
    }
  }

  return cleaned || 'http://localhost:7000';
}

export default getApiBaseUrl;
